<div class="items">
  <div *ngFor="let item of data; let index = index" class="item" [class.active]="index === active">
    <div class="date">{{item.createdAt | date}}</div>
    <h3 class="title" [innerHTML]="item.title.substring(0, 50)"></h3>
    <div class="text" [innerHtml]="item.excerpt.substring(0, 160) + '...' | stripHtml"></div>
    <a [href]="item.link + '?' + UTM" target="_blank">Read more</a>
  </div>
</div>
<div class="dots">
  <a *ngFor="let item of data; let index = index" href="javascript:void(0);" (click)="setActive(index)" class="dot" [class.active]="index === active"></a>
</div>